<script>
  import ApplicationLayout from '../../components/ApplicationLayout/index.svelte'
  import ItemForm from '../../components/ItemForm/index.svelte'

  let { item, property, spaces, containers, properties } = $props()
</script>

<svelte:head>
  <title>Edit Item | Maset</title>
</svelte:head>

<ApplicationLayout>
  <ItemForm {item} {property} {spaces} {containers} {properties} is_edit={true} />
</ApplicationLayout> 